import * as React from 'react';
import TerminalInstallationListAddForm from './../Layout/Form/TerminalInstallationListAddForm';
import {News} from 'Redux/Actions/Models/ErrorActionModel';
import {setNewsForMoment} from 'Redux/Actions/ErrorActions';
import * as TIModule from '../../Modules/TerminalInstallationModule';
import {connect} from 'react-redux';
import {withTranslation} from 'react-i18next';
import {RootState} from 'Redux/Reducers/_RootReducer';
import {EnumTypes} from "Models/EnumTypes/TerminalInstallationEnumTypes";

type Props = {
    history?: any;
    match: any;
};

type ConnectedDispatch = {
    setNews: (news: News) => Function;
    getTerminallInstalationById: (id: number) => Function;
    setTerminallInstalationOneElement: (terminaInstalationDto: TIModule.Types.TerminalInstallationOrderDto) => Function;
    editTerminallInstalationOrder: (formData: TIModule.Types.EditTerminalInstallationRequest, id: number) => Function;
};

type ConnectedProps = {
    t?: Function;
    terminalInstallationOneElement?: TIModule.Types.TerminalInstallationOrderDto;
};

type State = {};

class TerminalInstallationEdit extends React.Component<Props & ConnectedProps & ConnectedDispatch, State> {
    constructor(props: Props & ConnectedProps & ConnectedDispatch) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public async componentDidMount() {
        if (this.props.match.params.terminalInstallationId) {
            await this.props.getTerminallInstalationById(this.props.match.params.terminalInstallationId);
        }
    }

    public async handleSubmit(formData: any) {
        const {editTerminallInstalationOrder} = this.props;

        const editTerminalInstallationOrderData: TIModule.Types.EditTerminalInstallationRequest = {
            ...formData
        };

        const requestTemp: TIModule.Types.EditTerminalInstallationRequest = {
            carModel: editTerminalInstallationOrderData.carModel,
            carManufacturer: editTerminalInstallationOrderData.carManufacturer,
            sellerProposalNumber: editTerminalInstallationOrderData.sellerProposalNumber,
            vin: editTerminalInstallationOrderData.vin,
            terminalDeliverer: editTerminalInstallationOrderData.terminalDeliverer,
            plannedAddress: {...editTerminalInstallationOrderData.plannedAddress, countryCode: 'PL'},
            carCategory: editTerminalInstallationOrderData.carCategory,
            licensePlate: editTerminalInstallationOrderData.licensePlate,
            carSupplierCompanyName: editTerminalInstallationOrderData.carSupplierCompanyName,
            carSupplierPhoneNumber: editTerminalInstallationOrderData.carSupplierPhoneNumber,
            carSupplierEmail: editTerminalInstallationOrderData.carSupplierEmail,
            status: editTerminalInstallationOrderData.status,
            dashboardPhoto: editTerminalInstallationOrderData.dashboardPhoto,
            backPhoto: editTerminalInstallationOrderData.backPhoto,
            frontPhoto: editTerminalInstallationOrderData.frontPhoto,
            vinPhoto: editTerminalInstallationOrderData.vinPhoto,
            contactPersonInfo: editTerminalInstallationOrderData.contactPersonInfo ?? undefined
        };

        await editTerminallInstalationOrder(requestTemp, this.props.match.params.terminalInstallationId);
    }

    public render() {
        // tslint:disable-next-line:one-variable-per-declaration
        let vinPhoto,
        frontPhoto,
        backPhoto,
        dashboardPhoto

        this.props.terminalInstallationOneElement?.terminalInstallationPhotos?.forEach((file) => {
            switch (file.carPictureType) {
                case EnumTypes.CarPictureType.VIN:
                    vinPhoto = {
                        ...file,
                        name: file.fileName
                    }
                    break;
                case EnumTypes.CarPictureType.CAR_FRONT:
                    frontPhoto = {
                        ...file,
                        name: file.fileName
                    }
                    break;
                case EnumTypes.CarPictureType.CAR_BACK:
                    backPhoto = {
                        ...file,
                        name: file.fileName
                    }
                    break;
                case EnumTypes.CarPictureType.DASHBOARD:
                    dashboardPhoto = {
                        ...file,
                        name: file.fileName
                    }
                    break;
                default:
                    // ToDo: co w takim przypadku?
                    break;
            }
        })

        return (
            <div className="main__content main__content--scroll">
                <TerminalInstallationListAddForm
                    onSubmit={this.handleSubmit}
                    initialValues={{
                        ...this.props.terminalInstallationOneElement,
                        vinPhoto,
                        frontPhoto,
                        backPhoto,
                        dashboardPhoto
                    }}
                    {...{
                        typeForm: 'edit'
                    }}
                />
            </div>
        );
    }

    public componentWillUnmount() {
        this.props.setTerminallInstalationOneElement(null);
    }
}

function mapStateToProps(state: RootState) {
    return {
        terminalInstallationOneElement: state.terminalInstallationStore.terminalInstallationOneElement
    };
}

function mapDispatchToProps(dispatch: any): ConnectedDispatch {
    return {
        setNews: (news: News) => dispatch(setNewsForMoment(news)),
        getTerminallInstalationById: (terminallInstalationId: number) => dispatch(TIModule.Actions.getTerminallInstalationById(terminallInstalationId)),
        setTerminallInstalationOneElement: (terminaInstalationDto: TIModule.Types.TerminalInstallationOrderDto) => dispatch(TIModule.Actions.setTerminallInstalationOneElement(terminaInstalationDto)),
        editTerminallInstalationOrder: (formData: TIModule.Types.EditTerminalInstallationRequest, id: number) => dispatch(TIModule.Actions.editTerminallInstalationOrder(formData, id))
    };
}

export default withTranslation(['forms', 'errors', 'dictionary'])(connect(
    mapStateToProps,
    mapDispatchToProps
)(TerminalInstallationEdit) as React.ComponentClass<any>);



// WEBPACK FOOTER //
// ./src/components/TerminalInstallation/TerminalInstallationEdit.tsx